export const EXECUTION_TIMEOUT_SECONDS = 3600;
export const executionTimeoutVariables = {
  seconds: EXECUTION_TIMEOUT_SECONDS,
  hours: EXECUTION_TIMEOUT_SECONDS / 60 / 60,
};
